import { CheckOutlined, CloseOutlined, DeleteOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Dropdown, Modal, Row, Space, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import tagByStatus from "../components/TagByStatus";
import dayjs from "dayjs"
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { MY_REQUEST_TYPE } from "../schemas/MovementSchema";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Tabs } from "antd/lib";
import * as services from "../service/requestApprovalApi";
import { useSelector } from "react-redux";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import i18n from "i18n";
import styles from "./Input.module.css";





function formatDateTime(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
}




function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

const PendingApprovalMovementTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  isModalOpen = false,
  selectedRow = [],
  setSelectedRow = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  setModalOpen = () => { },
  selecttable = () => { },
  onApprove = () => { },
  onReject = () => { },
  onCancel = () => { },
  onReturn = () => { },
  onRowClick = () => { }
}) => {
  const { t, i18n } = useTranslation();
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [listEmployees, setListEmployees] = useState({});
  const [currentWorkflow, setCurrentWorkflow] = useState([]);





  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ),

  ];

  // useEffect(() => {
  //   if (isModalOpen) {
  //     getWorkflow();
  //   }
  // })


  const getWorkflow = (async ({ employeeId = "", flowRequestId = "" }) => {
    let data = [];

    data = await services.getWorkflowByRequestId({
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: employeeId,
      flowRequestId: flowRequestId,
    });
    setCurrentWorkflow(data?.data?.approvalSequence)

  })


  const columnmodal = [
    {
      title: <div className="text-table">{t("employment.label.no")}</div>,
      dataIndex: "index",
      key: "index",
      width: 150,
      render: (_, __, index) => index + 1,
    },
    {
      title: <div className="text-table">{t("employment.label.movement_fild")}</div>,
      dataIndex: "field",
      key: "field",
      render: (_, record) => {
        return (
          <div>
            {t(`movementfield.${record?.field?.toLowerCase()}`, {
              defaultValue: record?.field.toLowerCase(),
            })}
          </div>
        );
      },
      width: 200,
    },
    {
      title: <div className="text-table">{t("employment.label.old_value")}</div>,
      dataIndex: "oldValue",
      key: "oldValue",
      width: 200,
      render: (_, record) => {
        const text = i18n.language === "en" ? record.oldValueEn : record.oldValue;
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
    {
      title: <div className="text-table">{t("employment.label.new_value")}</div>,
      dataIndex: "newValue",
      key: "newValue",
      width: 200,
      render: (_, record) => {
        const text = i18n.language === "en" ? record.newValueEn : record.newValue;
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
  ];

  const columns = [
    {
      title: <div className="text-table">{t('req_id.req_id')}</div>,
      dataIndex: "sequence",
      key: "sequence",
    },
    {
      title: <div className="text-table">{t('name-surname')}</div>,
      dataIndex: "warnedEmployee",
      key: "warnedEmployee",
      render: (text, record) => {
        return i18n.language === 'en' ? record?.employee?.nameAndSurnameEn : record?.employee?.nameAndSurname
      }
    },
    {
      title: <div className="text-table">{t('translation.type')}</div>,
      dataIndex: "type",
      key: "type",
      render: (text, record) => {
        // console.log(record);
        return i18n.language === 'en' ? record?.movementType?.nameEn : record?.movementType?.name
      }
    },
    {
      title: <div className="text-table">{t('warning_letter.label.effective_date')}</div>,
      dataIndex: "startTime",
      key: "startTime",
      render: (_, record) => {
        return <div>{formatDate({ dateString: record?.effectiveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</div>
      }
    },
    // {
    //   title: <div className="text-table">{t('description.description')}</div>,
    //   dataIndex: "remark",
    //   key: "remark",
    //   render: (_, record) => {
    //     return record?.remark ? record?.remark : "-"
    //   }
    // },
    {
      title: <div className="text-table">{t('translation.document-status')}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (_, record) => {
        // return i18n.language === 'en' ? tagByStatus(record?.approveStatusEn) : tagByStatus(record?.approveStatus)
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => {
                    onRowClick(record);
                    getWorkflow({ employeeId: record.employee?.employeeId, flowRequestId: record.requestId });
                  },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },

                record.approveStatusEn === "Pending" ?
                  {
                    key: "2",
                    onClick: () => onApprove(record),
                    label: `${t("action.approve")}`,
                    icon: (
                      <CheckOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                  } : null,


                // {
                //   key: "3",
                //   onClick: () => onReturn(record),
                //   label: `${t("action.return")}`,
                //   icon: (
                //     <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                //   ),
                // },
                record.approveStatusEn === "Pending" ?
                  {
                    key: "3",
                    label: `${t("action.reject")}`,
                    icon: (
                      <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                    onClick: () => {
                      onReject(record);
                    }
                  } : null,
                // {
                //   key: "5",
                //   label: (
                //     <p
                //       onClick={() => {
                //         onCancel(record);
                //       }}
                //       style={{ color: "grey", fontSize: "14px" }}
                //     >
                //       CANCEL
                //     </p>
                //   ),
                //   icon: (
                //     <DeleteOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //       onClick={() => {
                //         onEdit(record);
                //       }}
                //     />
                //   ),
                // },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>

      ),
    },


  ];

  const visibleColumns = columns.filter((col) => col.visible);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });


  console.log("visibleColumns", visibleColumns);
  console.log("processedDataSource", processedDataSource);
  let language = i18n.language === 'en' ? "En" : ""



  return (
    <>
      <TableAntd
        loading={isLoading}
        dataSource={processedDataSource}
        pagination={{
          ...pagination,
          showTotal: (total, range) =>
            t("paginate.description")
              .replace("{min}", range[0])
              .replace("{max}", range[1])
              .replace("{total}", total),
        }}
        // dataSource={dataSource}
        rowKey={(record) => record.id}
        columns={columns}
        onChange={onChange}
      />
      <Modal
        title={t("salary.label.edit_movement")}
        open={isModalOpen}
        onCancel={() => {
          setModalOpen(false);
          setSelectedRow(null);
          // setCurrentMenu(MY_REQUEST_TYPE.DETAIL);
          // setMenu(MY_REQUEST_TYPE.DETAIL);
        }}
        width="1000px"
        footer={null}
      >

        <Tabs items={MENU} onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); }} />

        {(selectedMenu === MY_REQUEST_TYPE.DETAIL) && (
          <>
            <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
              {/* <Col span={24}>
          </Col>
          <Col span={12}>
            <span>{t("document.create_date")}: <strong>{selectedRow?.sequence || "-"}</strong></span>
          </Col>
          <Col span={12}>
            <span>{t("document.effective_date")}: <strong>{dayjs(selectedRow?.effectiveDate).format("DD/MM/YYYY") ? i18n.language === "en" ? dayjs(selectedRow?.effectiveDate).format("DD/MM/YYYY") : dayjs(selectedRow?.effectiveDate).format("DD/MM/BBBB") : '-'} </strong></span>
          </Col>
          <Col span={12}>

            <span>{t("document.type")}:  <strong>{i18n.language === "en" ? selectedRow?.movementType?.nameEn : selectedRow?.movementType.name}</strong></span>
          </Col>
          <Col span={12}>
          
            {selectedRow?.movementDetails?.approveStatusEn === "Approved" ?
              <span>{t("document.approved_date")}: <strong>{selectedRow?.movementDetails?.updateBy === 'null' ? dayjs(selectedRow?.movementDetails?.createDate).format("DD/MM/YYYY") : dayjs(selectedRow?.movementDetails?.createDate).format("DD/MM/YYYY")}</strong></span>
              : <span>{t("document.approved_date")}: <strong> - </strong></span>
            }
          </Col> */}
              <Col span={24}>
              </Col>
              <Col span={12}>
                <span>{t("document.number")}: <strong>{selectedRow?.sequence || "-"}</strong></span>
              </Col>
              <Col span={12}>
                <span>{t("document.create_date")}: <strong>{formatDate({ dateString: selectedRow?.createDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
              </Col>
              <Col span={12}>
                <span>{t("document.created_by")}: <strong>{i18n.language === "en" ? selectedRow?.createBy?.nameEn : selectedRow?.createBy?.name} {i18n.language === "en" ? selectedRow?.createBy?.surNameEn : selectedRow?.createBy?.surName}</strong></span>
              </Col>
              <Col span={12}>
                <span>{t("document.effective_date")}: <strong>{formatDate({ dateString: selectedRow?.effectiveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
              </Col>

              {/* <Col span={12}>
                {selectedRow?.approveStatusEn === "Approved" ? (
                  <span>{t("document.approved_date")}: <strong>{selectedRow?.approveDate !== 'null' ? formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
                ) : (
                  <span>{t("document.approved_date")}: <strong>-</strong></span>
                )}
              </Col> */}

              <Col span={12}>
                <span>{t("document.type")}: <strong>{i18n.language === "en" ? selectedRow?.movementType.nameEn : selectedRow?.movementType.name}</strong></span>
              </Col>
              {/* <Col span={12}>
                <span>{t("document.approved_by")}:
                  <strong>
                    {selectedRow?.timeline
                      ?.filter(item => item.approveStatusEn === "Approved")
                      .map((item, index) => (
                        <div key={index}>
                          {t("document.approver_number")} {index + 1} :
                          {i18n.language === "en"
                            ? `${item.employee.nameEn} ${item.employee.surNameEn}`
                            : `${item.employee.name} ${item.employee.surName}`}
                        </div>
                      ))}
                  </strong>
                </span>
              </Col> */}
            </Row>
            {selectedRow ? (
              <TableAntd
                dataSource={selecttable}
                columns={columnmodal}
                pagination={false}
                bordered
              />
            ) : (
              <p>{t("common.no_data")}</p>
            )}

          </>)}

        {selectedMenu === MY_REQUEST_TYPE.APPROVALSEQ && (
          <>
            {Array.isArray(currentWorkflow) &&
              currentWorkflow?.map((workflow, index) => (
                <>
                  <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                  <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                    <Row>
                      <Col span={16}>
                        <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                      </Col>
                      <Col span={8}>
                        <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                      </Col>
                      <Col span={16}>
                        <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                        <> </>
                        {workflow?.listEmployees?.length > 3 ? (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={() => {
                              setOpenListEmployee(true);
                              setListEmployees(workflow?.listEmployees);
                            }}
                            style={{
                              display: "inline-block",
                              borderRadius: "36px",
                              padding: "4px 12px",
                              fontSize: "0.7vw",
                              color: "#fff",
                              background: "var(--primary-color)",
                              textDecoration: "none",
                              fontWeight: "bold",
                              border: "1px solid var(--primary-color)",
                              cursor: "pointer"
                            }}

                          >
                            {`+ ${workflow?.listEmployees?.length - 3} ...`}
                          </a>
                        ) : ""}
                      </Col>
                      <Col span={8}>
                        <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                      </Col>
                    </Row>
                    <Row >
                      <Col span={16} style={{ marginTop: '10px' }}>
                        <label>
                          {workflow?.workFlowtype}
                        </label></Col>
                      <Col span={8} style={{ marginTop: '10px' }} >
                        <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                      </Col>
                    </Row>
                  </Card >
                </>
              ))}
          </>
        )}


        {selectedRow?.approveStatusEn === "Pending" && (
          <>
            <Row gutter={[16, 16]} style={{ marginTop: "16px" }} />

            <Row justify="end">
              <Space size={12} className={styles.filterbtn}>
                <Button
                  type="default"
                  onClick={() => {
                    onReject(selectedRow)
                    setModalOpen(false);
                  }}
                  style={{
                    height: "40px", borderRadius: "8px",
                    padding: "8px 16px"
                  }}>
                  {t("action.reject").toUpperCase()}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    onApprove(selectedRow)
                    setModalOpen(false);
                  }}
                  style={{
                    height: "40px", borderRadius: "8px",
                    backgroundColor: "var(--button-color)",
                    padding: "8px 16px"
                  }}>
                  {t("action.approve").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </>
        )}



        {openListEmployee && (
          <Modal title={t("leave_type.label.approver")}
            open={openListEmployee}
            onCancel={() => setOpenListEmployee(false)}
            footer={false}
            width="510px"
            maskClosable={false}
          >
            <Card size="small" style={{ border: "1px solid #000" }}>
              {listEmployees?.map((employee, index) => (
                <label key={index}>
                  {employee}
                  <br />
                </label>
              ))}
            </Card>
          </Modal>
        )}

      </Modal>




    </>

  );
};

export default PendingApprovalMovementTable;
